import type { FeatureConfig } from '@seek/hirer-feature-toggle';

export const FEATURE_EXPERIMENT_JOB_LIST_A_A_BASIC =
  'experiment-job-list-a-a-basic';
export const FEATURE_RELEASE_EXAMPLE = 'release-example';

export const features: FeatureConfig[] = [
  {
    key: FEATURE_RELEASE_EXAMPLE,
    name: 'Release Example',
    description: 'This is an example release toggle',
    variants: [true, false],
    fallback: false,
  },
  {
    key: FEATURE_EXPERIMENT_JOB_LIST_A_A_BASIC,
    name: 'Job List A/A Basic',
    description:
      'An A/A test setup to equally split traffic within the defined segment',
    variants: ['control', 'treatment', 'default'],
    fallback: 'default',
  },
];
